import { Check } from "lucide-react";
import { Reveal, SectionHead } from "./Reveal";
import { CheckoutButton } from "./CheckoutButton";

const FREE = ["5 recordings, free", "Notes, summaries, tasks & reminders", "Searchable library"];
const PRO = ["Keep recording after your free 5", "Everything in Free", "Tasks & reminders created automatically", "Cancel anytime"];

const List = ({ items, tone }) => (
  <ul className="mt-8 grid gap-3 text-sm">
    {items.map((t) => (
      <li key={t} className="flex items-center gap-3"><Check className={`h-4 w-4 ${tone}`} />{t}</li>
    ))}
  </ul>
);

export const Pricing = () => (
  <section id="pricing" data-testid="pricing-section" className="py-24 lg:py-32">
    <div className="mx-auto max-w-7xl px-6 lg:px-10">
      <SectionHead eyebrow="Pricing" title="Try it free. Keep it for less than a coffee." sub="Start with 5 free recordings. Love it? Keep going for €4.99 a month." />
      <div className="grid gap-6 md:grid-cols-2 lg:max-w-4xl">
        <Reveal>
          <div data-testid="pricing-free-card" className="flex h-full flex-col rounded-2xl border border-white/10 bg-card p-8 lg:p-10">
            <p className="font-mono text-xs uppercase tracking-widest text-muted-foreground">Free</p>
            <p className="mt-4 font-display text-5xl font-extrabold">€0</p>
            <p className="mt-2 text-sm text-muted-foreground">Your first 5 recordings</p>
            <List items={FREE} tone="text-cyan" />
            <div className="flex-1" />
            <a href="#signup" data-testid="pricing-free-cta" className="mt-10 inline-flex h-12 items-center justify-center rounded-full border border-cyan/50 px-6 font-semibold text-cyan transition-colors hover:bg-cyan hover:text-black">
              Reserve my free recordings
            </a>
          </div>
        </Reveal>
        <Reveal delay={0.1}>
          <div data-testid="pricing-pro-card" className="beam flex h-full flex-col rounded-2xl bg-card p-8 lg:p-10">
            <p className="font-mono text-xs uppercase tracking-widest text-pink">Pro</p>
            <p className="mt-4 font-display text-5xl font-extrabold">€4.99<span className="text-lg font-normal text-muted-foreground">/month</span></p>
            <p className="mt-2 text-sm text-muted-foreground">After your free recordings</p>
            <List items={PRO} tone="text-pink" />
            <CheckoutButton id="pricing" className="mt-10" />
            <p className="mt-3 text-center font-mono text-[11px] text-muted-foreground">Secure payment by Stripe</p>
          </div>
        </Reveal>
      </div>
    </div>
  </section>
);
